import axios from 'axios';
import config from '../config';

const signup = async data => {
  const res = await axios.post(`${config.API_URL}/api/accounts/signup/`, data);
  return res;
};

export default signup;
